import { GlobalAxios } from "../axios/axios-config";
import {
  IProfileListClassificationsPayload,
  IProfileListClassification,
} from "../models/profile-list-classification";
import MainApi from "./mainApi.service";

const PROFILE_LIST_CLASSIFICATIONS_ROUTE =
  process.env.REACT_APP_IDENTIY + "/api/v1/ProfileListClassifications/";

export const createProfileListClassifications = (
  item: IProfileListClassificationsPayload
) => {
  return GlobalAxios.post(PROFILE_LIST_CLASSIFICATIONS_ROUTE, item);
};

export const updateProfileListClassifications = ({
  id,
  item,
}: {
  id: string;
  item: IProfileListClassificationsPayload;
}) => {
  return GlobalAxios.put(PROFILE_LIST_CLASSIFICATIONS_ROUTE + id, item);
};

export const deleteProfileListClassification = (id: string) => {
  return GlobalAxios.delete(PROFILE_LIST_CLASSIFICATIONS_ROUTE + id);
};

export class ProfileListClassificationsService extends MainApi<IProfileListClassification> {
  constructor() {
    super(PROFILE_LIST_CLASSIFICATIONS_ROUTE);
  }

  deleteItemById = (id: string) => deleteProfileListClassification(id);
}
